import { IRequest } from '@r1-frontend/shared/types/IRequest';

/*
* Промополоски с фильтром по городу
* https://master.api-content.sandbox.d2c.r-one.io/docs/v1#/%D0%9F%D1%80%D0%BE%D0%BC%D0%BE%D0%BF%D0%BE%D0%BB%D0%BE%D1%81%D0%BA%D0%B0/get_v1_promo_line
*/
export const promoLine = (providerId: number): IRequest => ({
    uri: '/v1/promo-line',
    method: 'GET',
    headers: { 'ProviderId': `${providerId}` },
});
